import { createColumn } from "@/lib/table/columnFactory";
import { TicketActionsCell } from "./cells/TicketCells";
import type { Ticket, TicketColumnSettings } from "./types";

export const actionsColumnFactory = (settings: TicketColumnSettings) =>
  createColumn<Ticket>({
    id: "actions",
    header: () => <span className="sr-only">Actions</span>,
    cell: ({ row }) => <TicketActionsCell ticket={row.original} iconClass={settings.iconClass} />,
    size: settings.colWidth.actions,
    enableSorting: false,
    enableHiding: false,
  });
